import React from 'react';
import Item from "components/LM/Voice/Item";
import { ExternalLink } from "react-feather";
import TooltipWrapper from "components/LM/common/TooltipWrapper";

function Media(props) {
	const { media, type, checked, onToggle, ...otherProps } = props;

	let printMediaType;
	if (type === 'print') {
		printMediaType = media.supplement_of == null ? 'Main' : 'Supplement';
	}

	let error;
	if (media.error) {
		error = <p className="mb-0 text-danger">
			<em>Error: {media.error}</em>
		</p>
	}

	let warning;
	if (media.warning) {
		warning = <p className="mb-0 text-warning">
			<em>{media.warning}</em>
		</p>
	}

	return (
		<Item
			id={`media_${type}_${media.id}`}
			className={`item bg-error`}
			type={type}
			checked={checked}
			onToggleItem={onToggle}
			addedAt={media.added_at}
			{...otherProps}>
			<MediaLink media={media} type={type} />
			<p className="media-type text-black-50 mb-0">{media.id} {printMediaType}</p>
			{error}
			{warning}
		</Item>
	);

}

function MediaLink({ media, type }) {
	const isInactive = media.status?.value === 'inactive';
	if (type === 'online') {
		return <>
			<TooltipWrapper
				tooltip={media.name}
				placement="top"
			>
				<a href={`${process.env.REACT_APP_ORANGETOOL_URL}/media/edit#${media.id}`} target='_blank' className={`name text-ellipsis-title ${isInactive ? "text-danger" : ""}`} rel='noopener noreferrer'>{media.name}{isInactive ? ' (inactive)' : ''}</a>
			</TooltipWrapper>
			<a href={media.url} target='_blank' className='external-link' rel='noopener noreferrer'><ExternalLink className="feather align-middle mr-2 icon mb-1" /></a>
		</>
	} else {
		const mediaName = isInactive ? (
			<span className='text-danger'>{media.name} {media.country} (inactive)</span>
		) : (
			<>{media.name} {media.country}</>
		);
		return (
			<TooltipWrapper
				tooltip={`${media.name} ${media.country}`}
				placement="top"
			>
				<span>{mediaName}</span>
			</TooltipWrapper>
		)
	}
}

export default Media;
